import { render, staticRenderFns } from "./ListMessageCounter.vue?vue&type=template&id=4860fae0&scoped=true&"
import script from "./ListMessageCounter.vue?vue&type=script&lang=js&"
export * from "./ListMessageCounter.vue?vue&type=script&lang=js&"
import style0 from "./ListMessageCounter.vue?vue&type=style&index=0&id=4860fae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860fae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4860fae0')) {
      api.createRecord('4860fae0', component.options)
    } else {
      api.reload('4860fae0', component.options)
    }
    module.hot.accept("./ListMessageCounter.vue?vue&type=template&id=4860fae0&scoped=true&", function () {
      api.rerender('4860fae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ListMessageCounter.vue"
export default component.exports